import React, { useState } from 'react';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import { Search } from '../search/search';
import { DataEntity } from '../../types/data';
import { BackBurger, Burger } from '../../icons';
import style from './navbar.module.css';

export interface NavbarProps {
  data: DataEntity;
  isTocOpen: boolean;
  onToggleToc: () => void;
}

export default function Navbar({ data, onToggleToc, isTocOpen }: NavbarProps) {
  const [searchPhrase, setSearchPhrase] = useState('');
  const [hasFocus, setFocus] = useState(false);

  const handleOnBlur = () => {
    setTimeout(setFocus, 200, false);
  };

  return (
    <div className={style.root} data-desktop>
      <div className={style.group}>
        <div role="button" className={style.menu} onClick={onToggleToc} title={isTocOpen ? 'Collapse' : 'Expand'}>
          {isTocOpen ? <BackBurger /> : <Burger />}
        </div>
        <Breadcrumbs />
      </div>
      <div className={style.search}>
        <div className={`${style.searchIcon} fas fa-search`} />
        <input
          type="text"
          className={style.input}
          value={searchPhrase}
          onChange={(e) => setSearchPhrase(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => handleOnBlur()}
        />
        {hasFocus && <Search data={data} query={searchPhrase} />}
      </div>
    </div>
  );
}
